import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "PageCustomProducts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddCustomProduct = _resolveComponent("AddCustomProduct")!
  const _component_TableAddedProducts = _resolveComponent("TableAddedProducts")!
  const _component_CustomBudgetBreakdown = _resolveComponent("CustomBudgetBreakdown")!
  const _component_CustomProductModal = _resolveComponent("CustomProductModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AddCustomProduct),
    _createVNode(_component_TableAddedProducts),
    _createVNode(_component_CustomBudgetBreakdown),
    (_ctx.customProductModalActive)
      ? (_openBlock(), _createBlock(_component_CustomProductModal, {
          key: 0,
          title: _ctx.selectedCustomProductName,
          description: _ctx.selectedCustomProductDescription,
          price: _ctx.selectedCustomProductPrice,
          date: _ctx.selectedCustomProductDate,
          onCloseModal: _ctx.resetSelectedValues
        }, null, 8 /* PROPS */, ["title", "description", "price", "date", "onCloseModal"]))
      : _createCommentVNode("v-if", true)
  ]))
}